import { PvsPatient, Contact, Examination } from '../types';
import { PvsSelectOptions } from '../constants';

const openPatientInPVS = async (patientPVSId: string) =>
  globalThis.electron?.gdt?.openPatientInPVS?.(patientPVSId);

const onFileWrite = (cb: Function) => globalThis.electron?.gdt?.onFileWrite(cb);

const removeOnFileWriteListener = () => globalThis.electron?.gdt?.removeOnFileWriteListener?.();

const setSelectedPVS = (pvs: PvsSelectOptions) => globalThis.electron?.gdt?.setSelectedPVS?.(pvs);

const getSelectedPVS = () => globalThis.electron?.gdt?.getSelectedPVS?.() ?? '';

const getSyncPatientsPath = () => globalThis.electron?.gdt?.getSyncPatientsPath?.() ?? '';

const setSyncPatientsPath = (path: string) => globalThis.electron?.gdt?.setSyncPatientsPath?.(path);

const getSyncPatientsFileName = () => globalThis.electron?.gdt?.getSyncPatientsFileName?.() ?? '';

const setSyncPatientsFileName = (fileName: string) =>
  globalThis.electron?.gdt?.setSyncPatientsFileName?.(fileName);

const getOpenPatientInPVSPath = () => globalThis.electron?.gdt?.getOpenPatientInPVSPath?.() ?? '';

const setOpenPatientInPVSPath = (path: string) =>
  globalThis.electron?.gdt?.setOpenPatientInPVSPath?.(path);

const getOpenPatientInPVSFileName = () =>
  globalThis.electron?.gdt?.getOpenPatientInPVSFileName?.() ?? '';

const setOpenPatientInPVSFileName = (fileName: string) =>
  globalThis.electron?.gdt?.setOpenPatientInPVSFileName?.(fileName);

const getOpenPatientInMedflexPath = () =>
  globalThis.electron?.gdt?.getOpenPatientInMedflexPath?.() ?? '';

const setOpenPatientInMedflexPath = (path: string) =>
  globalThis.electron?.gdt?.setOpenPatientInMedflexPath?.(path);

const getOpenPatientInMedflexFileName = () =>
  globalThis.electron?.gdt?.getOpenPatientInMedflexFileName?.() ?? '';

const setOpenPatientInMedflexFileName = (fileName: string) =>
  globalThis.electron?.gdt?.setOpenPatientInMedflexFileName?.(fileName);

const multiSyncPatients = (path: string, contacts: any[]) =>
  globalThis.electron?.gdt?.multiSyncPatients?.(path, contacts);

const handleSyncPatient = (pvsPatient: PvsPatient, contacts: Contact[]) =>
  globalThis.electron?.gdt?.handleSyncPatient?.(pvsPatient, contacts);

const getWriteExaminationPath = () => globalThis.electron?.gdt?.getWriteExaminationPath?.() ?? '';

const setWriteExaminationPath = (path: string) =>
  globalThis.electron?.gdt?.setWriteExaminationPath?.(path);

const getWriteExaminationFileName = () =>
  globalThis.electron?.gdt?.getWriteExaminationFileName?.() ?? '';

const setWriteExaminationFileName = (fileName: string) => {
  globalThis.electron?.gdt?.setWriteExaminationFileName?.(fileName);
};

const writeExamination = async (examination: Examination) =>
  globalThis.electron?.gdt?.writeExamination?.(examination);

const getDownloadPath = () => globalThis.electron?.gdt?.getDownloadPath?.() ?? '';

const setDownloadPath = (path: string) => globalThis.electron?.gdt?.setDownloadPath?.(path);

export default {
  onFileWrite,
  removeOnFileWriteListener,
  selectedPVS: {
    set: setSelectedPVS,
    get: getSelectedPVS,
  },
  syncPatients: {
    getPath: getSyncPatientsPath,
    setPath: setSyncPatientsPath,
    getFileName: getSyncPatientsFileName,
    setFileName: setSyncPatientsFileName,
    multiSync: multiSyncPatients,
    sync: handleSyncPatient,
  },
  openPatientInPVS: {
    getPath: getOpenPatientInPVSPath,
    setPath: setOpenPatientInPVSPath,
    getFileName: getOpenPatientInPVSFileName,
    setFileName: setOpenPatientInPVSFileName,
    open: openPatientInPVS,
  },
  openPatientInMedflex: {
    getPath: getOpenPatientInMedflexPath,
    setPath: setOpenPatientInMedflexPath,
    getFileName: getOpenPatientInMedflexFileName,
    setFileName: setOpenPatientInMedflexFileName,
  },
  writeExamination: {
    getPath: getWriteExaminationPath,
    setPath: setWriteExaminationPath,
    getFileName: getWriteExaminationFileName,
    setFileName: setWriteExaminationFileName,
    getDownloadPath,
    setDownloadPath,
    write: writeExamination,
  },
};
